import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useFacebookPixelContext } from '@/components/FacebookPixelProvider';

/**
 * En una SPA el PageView inicial lo dispara la inicialización del pixel.
 * Este componente registra sólo los cambios de ruta posteriores, sin duplicar.
 */
export const PixelRouteTracker = () => {
  const location = useLocation();
  const { trackPageView } = useFacebookPixelContext();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname;
    if (lastPath.current === null) {
      // Primera carga: el PageView ya se envió al inicializar el pixel.
      lastPath.current = path;
      return;
    }
    if (lastPath.current === path) return;
    lastPath.current = path;
    trackPageView();
  }, [location.pathname, trackPageView]);

  return null;
};

export default PixelRouteTracker;
